export const alertConstantes = Object.freeze({
  ALERT_INFO: 1,
  ALERT_WARNING: 2,
  ALERT_DANGER: 3,
});
